module.exports = __webpack_public_path__ + "fonts/lato-regular-webfont.woff";


//////////////////
// WEBPACK FOOTER
// ./src/common/fonts/Lato/lato-regular-webfont.woff
// module id = 3432
// module chunks = 0